
import axios from 'axios';
import { API_URL, X_API_KEY, X_API_VERSION } from '../conf.js';
import { getCookie } from '../shared/utils/cookies';
import { axiosInterceptors } from '../shared/utils/axiosInterceptors';


export const getOfferByBrand = (params) => {
 
  var url = API_URL + '/offers?';
  var queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
  url += queryString;
  // Axios Data
  const axiosData = {
    method: 'GET',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'X-Api-Key': X_API_KEY,
      'X-Api-Version' : X_API_VERSION,
      'Authorization': 'Bearer ' + getCookie("_str")
    }
  };
  const axiosInstance = axios.create();
  axiosInterceptors(axiosInstance);
  return axiosInstance(axiosData)
    .then(response =>  ({ items: response.data['items'], meta: response.data["meta"] }))
    .catch(err => {
      console.log('AXIOS ERROR:', err.response);
    });
};